import { render, staticRenderFns } from "./ReminderDialog.vue?vue&type=template&id=071f31df&"
import script from "./ReminderDialog.vue?vue&type=script&lang=js&"
export * from "./ReminderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports